import React from 'react';
import { GraduationCap, TrendingUp, Check } from 'lucide-react';

const points = [
  'Personally teaches every batch',
  'NISM RA Certified — SEBI framework',
  '500+ students trained in Bhopal',
  'Small batches — real attention',
  '5+ years active trading experience',
  'Technical analysis specialist',
  'Options trading expert',
  'Post-course support included',
];

const Founder = () => {
  return (
    <section className="bg-white py-16 sm:py-20" id="founder" data-testid="founder-section">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-6xl">
        <div className="mb-10 sm:mb-12">
          <div className="inline-flex items-center gap-1.5 bg-green-100 text-green-800 px-3.5 py-1 rounded-full text-xs font-bold uppercase tracking-wider mb-3">
            Why Trust Us
          </div>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold text-gray-900 leading-tight mb-3">
            Learn Directly from Bhopal's <span className="text-green-600">NISM Certified</span> Research Analyst
          </h2>
          <p className="text-base sm:text-lg text-gray-600 max-w-2xl">
            Unlike large institutes where you never meet the founder — at Stocks Vision Academy, Deepak Singhai personally teaches every single batch.
          </p>
        </div>

        <div className="bg-gradient-to-br from-green-50 to-white border-2 border-green-200 rounded-3xl p-6 sm:p-10 lg:p-12 grid grid-cols-1 lg:grid-cols-[260px_1fr] gap-8 lg:gap-12 items-start">
          {/* Left: Photo + Badges */}
          <div className="text-center">
            <div className="w-32 h-32 sm:w-36 sm:h-36 mx-auto bg-green-600 rounded-2xl flex items-center justify-center text-4xl sm:text-5xl font-extrabold text-white font-sans shadow-lg" data-testid="founder-photo-placeholder">
              DS
            </div>
            <div className="mt-4">
              <div className="text-xl font-extrabold text-gray-900">Deepak Singhai</div>
              <div className="text-sm text-gray-500 mb-4">Founder, Stocks Vision Academy</div>

              <div className="bg-green-600 text-white p-3.5 rounded-xl text-left mb-2.5 shadow-sm">
                <div className="flex items-start gap-2">
                  <GraduationCap className="h-5 w-5 flex-shrink-0 mt-0.5" />
                  <div>
                    <div className="text-sm font-bold leading-snug">NISM Certified Research Analyst (RA)</div>
                    <div className="text-xs opacity-90 mt-1 leading-snug">
                      National Institute of Securities Markets<br/>Established by SEBI, Govt. of India
                    </div>
                  </div>
                </div>
              </div>

              <div className="bg-green-100 text-green-800 px-3.5 py-2 rounded-lg text-sm font-bold flex items-center justify-center gap-1.5">
                <TrendingUp className="h-4 w-4" />
                5+ Years Active Market Experience
              </div>
            </div>
          </div>

          {/* Right: Content */}
          <div>
            <h3 className="text-2xl sm:text-3xl font-extrabold text-gray-900 mb-4 leading-tight">
              The Trainer You Learn From <span className="text-green-600">Is The Founder Himself</span>
            </h3>
            <p className="text-gray-700 leading-relaxed mb-3">
              Deepak Singhai is a stock market trader and educator with over 5 years of hands-on expertise in technical analysis, options trading, and live market strategies. As a NISM Certified Research Analyst (RA) — certified by the National Institute of Securities Markets established by SEBI — Deepak Singhai brings credentialed, structured, and deeply practical education to every student in Bhopal.
            </p>
            <p className="text-gray-700 leading-relaxed">
              Most institutes in Bhopal are run by large teams where you never meet the actual founder. At Stocks Vision Academy, Deepak Singhai personally teaches every batch, answers every doubt, and stays available even after your course is complete.
            </p>

            <ul className="grid grid-cols-1 sm:grid-cols-2 gap-2.5 mt-6">
              {points.map((p) => (
                <li key={p} className="flex items-center gap-2 text-sm font-medium text-gray-800">
                  <span className="w-5 h-5 bg-green-100 text-green-700 rounded-full flex items-center justify-center flex-shrink-0">
                    <Check className="h-3 w-3" strokeWidth={3} />
                  </span>
                  {p}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Founder;
